// extracted by mini-css-extract-plugin
module.exports = {"content":"meteoinfo_content__1Pqsi","center":"meteoinfo_center__HfSY2"};